import { Stack, Typography } from "@mui/material";


export default function TitleAndContent({ title, content }) {
    return (
        <Stack sx={{
            alignItems: "center"
        }}>
            <Typography align="center" sx={{
                fontSize: '5rem',
                lineHeight: '7.5rem',
                fontWeight: 'bold',
                marginBottom: { xs: '1rem', sm: "4rem" },
                whiteSpace: "pre-wrap"
            }}>
                {title}
            </Typography>
            <Typography align="center" sx={{
                fontSize: '3rem',
                lineHeight: '4.5rem',
                marginBottom: '4rem',
                whiteSpace: "pre-wrap",
                color: '#A19FA8'
            }}>
                {content}
            </Typography>
        </Stack>
    )
}